//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import { Button   } from '@mui/material';

// === API ===
import { prokey_server } from 'api/prokey/prokey.axios';

//#endregion

//-----------------------------------------------------------------
export function TaskResetButton(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  //#endregion

  //#region [STYLES]

  const _styles = {
    reset_button: {
      flex     : '1 1 23%' ,
      minWidth : '10rem'   ,
      margin   : '0.5rem'  ,
    }
  }

  const RESET_BUTTON = {
    sx       : _styles.reset_button,
    variant  : 'contained'       ,
    color    : 'primary'         ,
    onClick  : handleClick       ,
    children : [ 'Reset Batch' ] ,
  }

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  async function handleClick() {
    //-----------------------------------------------------------------
    if(!props.task) return;
    prokey_server.clearTask(props.task);
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return <Button { ...RESET_BUTTON } />
  };

  //#endregion

  return display();
}